import React, { useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import Typography from "@mui/material/Typography";
import Checkbox from "@mui/material/Checkbox";
import Button from "@mui/material/Button";
import CustomModal from "../../../../modal/CustomModal";

import { showMacrosModal, hideMacrosModal } from "../../../../../actions/walkthrough";

//Utils
import { formatIngredient, decimalToFraction } from "../../../../../utils/recipe";

//Modals
import FinishRecipeEditModal from "./FinishRecipeEditModal";
import PlusModal from "../../../../plus/PlusModal";

//TODO:
/*
Move sectionIngredients into it's own modal for display here
Clean up text
Only include ingredients that are measured
Properly display output yield, show amount minus servingsEaten as leftovers? Do math on amount/unit from servings ratio
*/

const FinishRecipeSection = ({
  section,
  sectionIndex,
  checked,
  setChecked,
  showMacrosModal,
  hideMacrosModal,
  walkthrough: { modals },
  plus: { isPlus },
}) => {
  const [showIngredientsModal, setShowIngredientsModal] = useState(false);
  const [showPlusModal, setShowPlusModal] = useState(false);

  const handleTrackMacros = () => {
    if (!isPlus) {
      setShowPlusModal(true);
      return;
    }
    showMacrosModal(sectionIndex);
  };

  const handlePlusModalClose = () => {
    setShowPlusModal(false);
  };

  return (
    <>
      <CustomModal open={showIngredientsModal} handleClose={() => setShowIngredientsModal(false)} type="bottom">
        <FinishRecipeEditModal
          section={section}
          sectionIndex={sectionIndex}
          showMacrosModal={showMacrosModal}
          handleClose={() => setShowIngredientsModal(false)}
        />
      </CustomModal>
      <CustomModal open={showPlusModal} handleClose={handlePlusModalClose} type="bottom">
        <PlusModal handleClose={handlePlusModalClose} />
      </CustomModal>
      <div className="flex items-start pt-4 px-4">
        <div>
          <Checkbox
            className="p-0"
            checked={checked}
            color="primary"
            size="small"
            onChange={(e) => {
              setChecked(sectionIndex, e.target.checked);
            }}
          />
        </div>
        <div className="ml-2 mt-1 flex flex-col w-full">
          <Typography variant="h6" className="font-normal leading-none pb-2">
            {section.title}
          </Typography>
          <div className="w-full flex flex-col gap-4">
            {section?.ingredients?.length > 0 && (
              <div>
                <Typography variant="subtitle2" className="font-normal">
                  Ingredients:
                </Typography>

                <Typography variant="subtitle1">
                  {section?.ingredients?.length} ingredient{section?.ingredients?.length === 1 ? "" : "s"} used
                </Typography>
                {section?.yield && (
                  <div>
                    <Typography variant="subtitle2" className="font-normal">
                      Yield:
                    </Typography>
                    <div className="flex flex-grow-0 gap-1">
                      {section.yield.amount && (
                        <Typography variant="subtitle2" className="font-normal leading-snug">{`${decimalToFraction(
                          section.yield.amount
                        )} `}</Typography>
                      )}
                      {section.yield.unit && section.yield.unit.shortName && (
                        <Typography
                          variant="subtitle2"
                          className="font-normal leading-snug"
                        >{`${section.yield.unit.shortName} `}</Typography>
                      )}
                      {section.yield.ingredient && section.yield.ingredient.name && (
                        <Typography variant="subtitle2" className="font-medium leading-snug">
                          {formatIngredient(
                            section.yield.ingredient,
                            section?.yield?.amount ? section.yield.amount : 1,
                            section?.yield?.unit?.type ? section?.yield?.unit?.type : null
                          )}
                        </Typography>
                      )}
                    </div>
                  </div>
                )}
                <Button
                  onClick={() => setShowIngredientsModal(true)}
                  className="p-0 hover:bg-transparent"
                  disableElevation
                  disableRipple
                >
                  <Typography variant="subtitle2" className="text-xs text-mainGreen font-medium">
                    Edit Ingredients
                  </Typography>
                </Button>
              </div>
            )}
            {section?.servingsEaten && (
              <div>
                <Typography variant="subtitle2" className="font-normal">
                  Insights:
                </Typography>
                {isPlus && (
                  <Typography variant="subtitle1">
                    Eating <span className="font-medium text-mainGreen">{section?.servingsEaten}</span> serving
                    {section?.servingsEaten === 1 ? "" : "s"}
                  </Typography>
                )}
                <Button
                  onClick={() => handleTrackMacros()}
                  className="p-0 hover:bg-transparent"
                  disableElevation
                  disableRipple
                >
                  <Typography variant="subtitle2" className="text-xs text-mainGreen font-medium">
                    Track Macros
                  </Typography>
                </Button>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  walkthrough: state.walkthrough,
  plus: state.plus,
});

export default connect(mapStateToProps, { showMacrosModal, hideMacrosModal })(FinishRecipeSection);
